import React, { Suspense } from 'react';
import { Outlet } from "react-router-dom";
import { Container } from '@mui/material'
import { Footer, Header } from '../components';


const LayoutPublic = () => {

    return (
        <>
            <Header />
            <main>
                <Suspense fallback={<div>Cargando...</div>}>
                    <Container sx={{ marginTop: 5, marginBottom: 5 }}>
                        <Outlet />
                    </Container>
                </Suspense>
            </main>
            <Footer />
        </>
    );
}

export default LayoutPublic;